const E = 640, T = 768, B = 1280;
export {
  B as DESKTOP_BREAKPOINT,
  E as MOBILE_BREAKPOINT,
  T as TABLET_BREAKPOINT
};
